import { Table, Text } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';
import ContactCell from '../components/ContactCell';
import AgentBranchCell from '../components/AgentBranchCell';
import ClosureReasonCell from '../components/ClosureReasonCell';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';

export default function ClosedLeadsTableRow({ row }) {
  const {
    closing_reason,
    days_of_follow_up,
    contact,
    qualification,
    branch,
    close_date,
    id,
    agent,
    assignment_date,
  } = row;

  return (
    <Table.RowDefault id={id} variant="secondary">
      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <ContactCell
          id={contact?.id}
          cellphone={contact?.cellphone}
          name={contact?.name}
          email={contact?.email}
          image={contact?.image}
          agent={agent}
          leadStatus={contact?.lead_status}
          relativeSelector="#closed-leads-modal"
          modal="closedLeads"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <AgentBranchCell
          agentId={agent?.id}
          agentName={agent?.name}
          branchName={branch?.name}
          image={agent?.profile_picture}
          relativeSelector="#closed-leads-modal"
          modal="closedLeads"
          withBoldTitle
          withBranch
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">
          {`${days_of_follow_up} ${Trans(
            translations,
            days_of_follow_up === 1 ? 'day' : 'days'
          )}`}
        </Text>
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <ClosureReasonCell
          qualification={qualification}
          reason={closing_reason}
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{assignment_date}</Text>
        <Text variant="body.fontSize13">{close_date}</Text>
      </Table.RowItemDefault>
    </Table.RowDefault>
  );
}
